export default __webpack_public_path__ + "static/media/XEMP-11.d335766f.jpg";